import { Stage } from './serviceConstants';

export const URLS = {
  ROOT: '/',
  DASHBOARD: '/dashboard',
  USERS: '/users',
  ROLES: '/roles',
  BOOKINGS: '/bookings',
  EDIT_INVENTORY: '/edit-inventory',
  ALLOWLIST: '/allowlist',
  ALLOWLIST_AE: '/allowlist/ae',
  ALLOWLIST_INVENTORY: '/allowlist/inventory',
  ALLOWLIST_ADVERTISERS: '/allowlist/advertisers',
  ALLOWLIST_CATEGORY: '/allowlist/category',
  ALLOWLIST_TYPE_OF_PURCHASE: '/allowlist/type-of-purchase',
  CREATE_ART_EVENT: '/create-art-event',
  ART_EVENT: '/art-events',
  UNAUTHORIZED_ACCESS: '/unauthorized-access',
} as const;

export const API_BASE_URLS = {
  [Stage.DEV]: 'http://localhost:3000',
  [Stage.BETA]: 'https://beta.adslotbookingtool.in-adtech.amazon.dev',
  [Stage.PROD]: 'https://prod.adslotbookingtool.in-adtech.amazon.dev',
} as const;
